import React from 'react';
import {
  UnorderedList,
  ListItem,
  OrderedList,
  Expander,
  Paragraph,
} from '@piggybank/core';
import { Translation } from 'srcAlias/client/locale';
export const GeneralInvestment = (path) => {
  return (
    <Expander
      name="generalInvestment"
      title={<Translation path="generalInvestment" />}
    >
      <Paragraph>
        <OrderedList type={'denary'}>
          {path.path.map((contentItem, idx) => {
            const mainTitle = contentItem[0].title;
            const mainContent = contentItem[0].content;
            const mainKey = `${mainTitle}-${idx}`;

            // Extracted the nested ternary into an independent statement
            let mainContentNode;
            if (Array.isArray(mainContent)) {
              if (mainTitle === 'Introduction') {
                mainContentNode = (
                  <div>
                    <OrderedList type={'denary'}>
                      {mainContent.slice(1, 4).map((item, i) => (
                        <ListItem key={`intro-${i}`}>{item}</ListItem>
                      ))}
                    </OrderedList>
                  </div>
                );
              } else {
                mainContentNode = mainContent.map((subContentItem, subIdx) => (
                  <div key={`mainContent-${subIdx}`}>{subContentItem}</div>
                ));
              }
            } else if (
              typeof mainContent === 'object' &&
              mainContent !== null
            ) {
              mainContentNode = (
                <OrderedList type={'denary'}>
                  {Object.entries(mainContent).map(([key, value]) => (
                    <ListItem key={key}>{String(value)}</ListItem>
                  ))}
                </OrderedList>
              );
            } else {
              mainContentNode = <div>{mainContent}</div>;
            }

            return (
              <ListItem key={mainKey}>
                {mainTitle}
                {mainContentNode}
                {contentItem.length > 1 && (
                  <OrderedList type={'denary'}>
                    {contentItem.slice(1).map((subContentItem, subIdx) => {
                      const subKey = `${
                        subContentItem.heading || 'sub'
                      }-${subIdx}`;
                      return (
                        <ListItem key={subKey}>
                          <>{subContentItem.heading}</>
                          {subContentItem.label &&
                            (Array.isArray(subContentItem.label) ? (
                              subContentItem.label.map(
                                (labelItem, labelIdx) => {
                                  if (typeof labelItem === 'object') {
                                    if (labelItem.listType) {
                                      return (
                                        <OrderedList
                                          type={labelItem.listType}
                                          key={`label-ol-${labelIdx}`}
                                        >
                                          {labelItem.listContent.map(
                                            (listItem, liIdx) => (
                                              <ListItem
                                                key={`label-ol-li-${liIdx}`}
                                              >
                                                {listItem.a}
                                                {listItem.b && (
                                                  <div>{listItem.b}</div>
                                                )}
                                              </ListItem>
                                            )
                                          )}
                                        </OrderedList>
                                      );
                                    }
                                    return (
                                      <UnorderedList
                                        key={`label-ul-${labelIdx}`}
                                      >
                                        {labelItem.listContent.map(
                                          (listItem, liIdx) => (
                                            <ListItem
                                              key={`label-ul-li-${liIdx}`}
                                            >
                                              {listItem.a}
                                              {listItem.b}
                                            </ListItem>
                                          )
                                        )}
                                      </UnorderedList>
                                    );
                                  }
                                  if (typeof labelItem === 'string') {
                                    if (labelItem.indexOf('<b>') !== -1) {
                                      return (
                                        <div key={`label-bold-${labelIdx}`}>
                                          <strong>{labelItem.slice(3)}</strong>
                                        </div>
                                      );
                                    }
                                    return (
                                      <div key={`label-str-${labelIdx}`}>
                                        {labelItem}
                                      </div>
                                    );
                                  }
                                  return null;
                                }
                              )
                            ) : (
                              <div>{subContentItem.label}</div>
                            ))}
                          {subContentItem.content && (
                            <OrderedList type={'denary'}>
                              {subContentItem.content.map((listItem, liIdx) => (
                                <ListItem key={`subContent-li-${liIdx}`}>
                                  {listItem.subHeading}
                                  {Array.isArray(listItem.content) ? (
                                    listItem.content.map((c, cIdx) => (
                                      <div key={`subContent-li-div-${cIdx}`}>
                                        {c}
                                      </div>
                                    ))
                                  ) : (
                                    <div>{listItem.content}</div>
                                  )}
                                </ListItem>
                              ))}
                            </OrderedList>
                          )}
                        </ListItem>
                      );
                    })}
                  </OrderedList>
                )}
              </ListItem>
            );
          })}
        </OrderedList>
      </Paragraph>
    </Expander>
  );
};
